import SonyaManips from "../../../../src/components/Suikoden/SonyaManip";
import SonyaData from "../../../../src/lib/Suikoden/Sonya/AnyPercentGlitchless.js";
import React from 'react';
export default {
  SonyaManips,
  SonyaData,
  React
};